import { render, staticRenderFns } from "./myPaper.vue?vue&type=template&id=09089b01"
import script from "./myPaper.vue?vue&type=script&lang=js"
export * from "./myPaper.vue?vue&type=script&lang=js"
import style0 from "./myPaper.vue?vue&type=style&index=0&id=09089b01&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports